module.exports = __webpack_public_path__ + "static/media/1CustomizedSolutions.f3b01299.svg";